export default __webpack_public_path__ + "media/wallpaper/two-full-0851b8e0.jpg";